export default class {
  organisation = ""
  organisationId = null
  secteurActivite = null
  rue1 = ""
  rue2 = ""
  ville = ""
  pays = null
  province = null
  codePostal = ""
  categorieEtablissement = null
  dateDeDebut = null
  fonction = ""
  lieuExercicePrincipal = false
  lieuCorrespondancePostale = false
  pratiqueAupresDuPublic = false
}